const $$splitComponentImporter = () => import('/app/src/routes/onboarding.tsr-split.component.tsx');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from "@tanstack/react-router";
import { needsOnboarding } from "@/lib/onboarding";
interface ProfileResp {
  role: string;
  name: string;
  firstName: string | null;
  lastName: string | null;
  phone: string | null;
}
export const Route = createFileRoute("/onboarding")({
  validateSearch: (search: Record<string, unknown>) => ({
    redirect: typeof search.redirect === "string" ? search.redirect : "",
    gate: search.gate === "1" || search.gate === 1 ? "1" : ""
  }),
  beforeLoad: async ({
    search
  }) => {
    const res = await fetch("/api/me/profile");
    if (!res.ok) throw redirect({
      to: "/login"
    });
    const profile = (await res.json()) as ProfileResp;
    if (!needsOnboarding(profile)) {
      throw redirect({
        to: search.redirect || "/"
      });
    }
    return {
      profile
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});